import { Controller, useFormContext } from 'react-hook-form';
import React, { useEffect, useState } from 'react';

import CustomInput from './CustomInput';

const ControlledTextInput = ({ name, maxLength = 100, isRequired = false, valueType = '', placeholder = '', isFullWidth = false }) => {
  const { control, getValues } = useFormContext();

  // 날짜 형식 자동 포맷팅 함수
  const formatDateInput = (value) => {
    if (!value) return '';

    // 숫자만 추출
    const numericValue = value.replace(/\D/g, '');

    // YYYY.MM 형식으로 포맷팅
    if (numericValue.length > 4) {
      return `${numericValue.slice(0, 4)}.${numericValue.slice(4, 6)}`;
    }
    return numericValue;
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired ? '필수 입력 항목입니다.' : undefined,
      }}
      render={({ field, fieldState }) => {
        // null 값을 빈 문자열로 처리
        const safeValue = field.value === null ? '' : field.value;

        return (
          <CustomInput
            {...field}
            value={safeValue}
            inputRef={field.ref}
            error={fieldState.error !== undefined}
            helperText={fieldState.error ? fieldState.error.message : ''}
            inputProps={{
              maxLength,
              placeholder,
            }}
            required={isRequired}
            maxWidth={isFullWidth ?? '100%'}
            onChange={(event) => {
              let { value } = event.target;

              // 변경된 값도 null 체크
              if (value === null) value = '';

              if (valueType === 'number') {
                // 숫자가 아닌 문자를 제거
                const numericValue = value.replace(/[^0-9]/g, '');
                field.onChange(numericValue);
              } else if (valueType === 'date') {
                // 숫자와 점만 허용
                value = value.replace(/[^\d.]/g, '');

                // 화면에 표시할 포맷팅된 값
                const formattedValue = formatDateInput(value);

                field.onChange(formattedValue); // 실제 저장되는 값은 숫자만
              } else {
                field.onChange(value);
              }
            }}
            autoFocus={fieldState.error !== undefined}
            autoComplete="off"
          />
        );
      }}
    />
  );
};

export default ControlledTextInput;
